import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import Typography from "@material-ui/core/Typography";
import React from "react";

const useStyle = makeStyles(theme => ({
    item: {
        'width': '200px',
        'margin': theme.spacing(2)
    }
}));
export const SubscriptionUsage = ({
    type,
    total,
    used,
    available
}: any) => {
    const classes = useStyle();
    const {t} = useTranslation();

    return (
               <div className={classes.item}>
                        <Typography variant="body1" display="block"
                        gutterBottom> {t(`Subscription.Overview.${type}`)} </Typography>
                        <Typography variant="h4">{total}</Typography>
                        <Typography variant="body1">{t('_Common.Labels.Used')} {used}</Typography>
                        <Typography variant="body1">{t('_Common.Labels.Available')} {available}</Typography>
        </div>
    );
};
